import { Box, HStack, Header, Link } from '@rbilabs/universal-components';

export const DrinksTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  fontFamily: Styles.fontFamily.body,
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: 2,
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: p.active ? Styles.color.tertiary : 'transparent',
      md: p.active ? Styles.color.black : 'transparent',
    },
  },

  borderBottomColor: p.active ? Styles.color.tertiary : 'transparent',
  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const DrinksTabLinkText = Header.withConfig<{ active?: boolean }>(p => ({
  color: p.active ? Styles.color.tertiary : Styles.color.tertiary,
  fontFamily: p.active ? Styles.fontFamily.base : Styles.fontFamily.body,
  marginTop: 0,
  fontSize: { md: 'sm' },
  lineHeight: { md: 'md' },
}));

export const DrinksTabsWrapper = HStack.withConfig({
  position: 'relative',
  width: 'full',
  height: Styles.layout.navHeight.mobile,
  marginY: '2px',
  paddingTop: 2,
  background: 'transparent',
});

export const TabsContent = Box.withConfig({
  marginTop: {
    base: '$6',
    md: '$8',
  },
});
